export const globalColumns = [ // columns, not categories
  'id', 'date', 'global_result', 'server_name'
];

export const hardwareColumns = [ // categories in allReportingColumns
  'system', 'cpu', 'ram_bank', 'disk', 'motherboard', 'bios', 'video_card', 'network_card',
  'sound_card', 'screen', 'disk_controler', 'webcam', 'battery', 'optical', 'other'
];

export const deviceWipeColumns = [ // columns, not categories
  'result', 'nb_disks_wiped'
];

export const diskWipeColumns = [ // columns, not categories
  'result', 'algorithm', 'eraser_rounds','time', 'manufacturer', 'model',
  'advertized_capacity', 'serial', 'health', 'uuid', 'ppid',
  'bps', 'customer_data', 'reallocated_sectors', 'power_on_hours', 'reported_uncorrectable_errors', 'command_timeout', 'current_pending_sector_count', 'offline_uncorrectable', 'disk_health_percentage', 'smart_attributes', 'rpm',
  "bus", "path", 'computed_health', 'computed_perf', 'order', 'lot'
];

export const imagingColumns = [
  'imaging_result', 'added_imageName', 'added_osversion', 'added_osarchitecture', 'added_usedSpace'
]

export const deploymentColumns = [
  'image_deployed', 'image_deployed_os', 'result', 'duration'
]

export const sbarColumns = [
  'activation_code', 'activation_type', 'activation_result', 'image_type'
]

export const manualInputsColumns = [
  'welcome_screen', 'questions_form'
]

export const tradeInColumns = [
  'code'
]

export const scriptsColumns = [  
  'script_value'
]

export const bootImageColumns = [
  'current_name', 'original_name', 'date', 'winpe_ver', 'launcher_ver', 'boot_type', 'secure_boot', 't2_security'
]


export const hexadecimalViewerColumns = [
  'result', 'disk_validated'
]

export const testsHardwareColumns = [ // categories in allReportingColumns
  'diag_general', 'diag_common', 'diag_cpu', 'diag_memory', 'diag_storage', 'diag_mainboard', 'diag_video_adapter', 'diag_network',
  'diag_audio', 'diag_screen', 'diag_user_inputs', 'diag_battery', 'diag_sensors', 'diag_other'
];

export const locksColumns = [
  'lock_bios_admin_password',     //  BIOS admin password lock
  'lock_bios_computrace_status'   //  BIOS Computrace status
]

//-----------------------------------------------

export const allReportingColumns = {
  system: [
    'manufacturer', 'product', 'serial_number', 'uuid', 'sku', 'chassis', 'system_version'
  ],

  cpu: [
    'total_sockets', 'free_sockets', 'manufacturer', 'model', 'socket', 'cpuid', 'nominal_frequency', 'maximum_frequency',
    'cores', 'threads', 'l1cache', 'l2cache', 'l3cache'
  ],

  ram_bank: [
    'total_amount', 'total_slots', 'free_slots', 'form_factor',
    'manufacturer', 'type', 'speed', 'size', 'serial_number', 'asset_tag', 'part_number', 'rank'
  ],

  disk: [    
    'nb_disks', 'total_size', 'manufacturer', 'model', 'advertized_capacity', 'real_capacity',
    'type', 'firmware', 'serial_number', 'connector', 'bus', 'world_wide_name', 'ppid', 'health',
    'remapped_sectors', 'bits_per_sector', 'hpa', 'dco', 'rpm'/*, 'computed_health', 'computed_perf'*/
  ],

  motherboard: [
    'manufacturer', 'model', 'version', 'serial', 'assettag', 'tpm_version'
  ],

  bios: [
    'manufacturer', 'version', 'date'
  ],

  video_card: [
    'manufacturer', 'model', 'driver', 'cores', 'allocated_memory_size', 'memory_bus', 'name'
  ],

  network_card: [
    'manufacturer', 'model', 'type', 'pnp', 'mac', 'driver', 'protocol_version'
  ],

  sound_card: [
    'manufacturer', 'model', 'pnp', 'driver'
  ],

  screen: [
    'manufacturer', 'model', 'size', 'resolution', 'serial_number', 'touch_screen', 'driver'
  ],

  disk_controler: [
    'manufacturer', 'model', 'pnp', 'driver'
  ],

  webcam: [
    /*'manufacturer',*/ 'model', 'pnp', 'driver'
  ],

  battery: [
    'manufacturer', 'model', 'chemistry', 'designed_capacity', 'full_charged_capacity',
    'rate', 'power_state', 'current_capacity', 'voltage', 'cycle_count', 'serial', 'wear_level', 'health_level'
  ],

  optical: [
    'manufacturer', 'model', 'firmware', 'media'
  ],

  other: [
    'bluetooth', 'biometrics', 'cardreader'
  ]
};


export const allDiagnosticColumns = {
  diag_general: [
    'global_result', 'nb_tests_run', 'nb_tests_passed', 'nb_tests_failed', 'list_tests_failed', 'nb_tests_skipped', 'list_tests_skipped'
  ],

  diag_common: [
    'tests_comments'
  ],

  diag_cpu: [    
    'full_test', 'general_purpose_instructions', 'floating_point_unit_instructions', 'prime_number_test',
    'maximum_heat', 'mmx', 'sse', 'sse2', 'sse3', 'aes', 'sse41', 'sse42', 'sse4a', 'avx',
    'fma3', 'apple_cpu_test'
  ],

  diag_memory: [
    'ram', 'ram_multi_process_torture', 'apple_memory_test'
  ],

  diag_storage: [
    'hdd_short_smart_test', 'hdd_long_smart_test', 'hdd_linear_read_test', 'hdd_random_read_test',
    'smart_attributes', 'hdd_smart_status', 'optical_drive_read_test', 'apple_storage_test'
  ],

  diag_mainboard: [
    'usb_ports', 'apple_usb_test', 'apple_thunderbolt_test'
  ],

  diag_video_adapter: [
    '2d_local_video_memory', '2d_all_available_memory', '2d_lines_and_bitmaps',
    '2d_emc_scrolling_characters', '2d_emc_reference_test_pattern', '3d', 'advanced_GPU_test', 'gpgpu', 'apple_gpu_test'
  ],

  diag_network: [
    'wired_lan', 'wifi_wan', 'apple_wired', 'apple_wifi', 'apple_bluetooth'
  ],
  
  diag_audio: [
    'internal_speaker', 'internal_microphone', 'output_jack', 'input_jack',
    'combo_jack', 'apple_audio_test'
  ],

  diag_screen: [
    'display_ports', 'apple_hdmi_controller_test', 'dead_pixel_test', 'screen_calibration_test', 'touchscreen'
  ],

  diag_user_inputs: [
    'keyboard', 'keyboard_status_led', 'apple_keyboard_test', 'apple_touch_id_test', 'apple_touch_bar_test', 'mouse_test', 'touchpad',
    'apple_trackpad_test', 'trackpoint'
  ],

  diag_battery: [
    'battery_wear_level', 'battery_charging_test', 'battery_drain_test', 'apple_battery_test'// , 'battery' 560-not used
  ],

  diag_sensors: [
    'accelerometer', 'lid_sensor', 'apple_lid_sensor', 'apple_ambient_light_sensor', 'apple_accelerometer_gyroscope_test'
  ],

  diag_other: [
    'card_reader', 'apple_card_reader', 'suspend_mode_test', 'webcam', 'apple_webcam', 
    'apple_case_handle_test', 'apple_serial_number_test', 'apple_smc_test', 'apple_firmware_test', 'apple_fan_test', 
    'apple_power_management_test', 'apple_power_adapter_test', 'apple_io_card', 'apple_antenna_connector_board_test',
    'quick_test'
  ],
}


export const allManualInputsColumns = {
  welcome_screen: [
    'input_value',
    'other_manual_inputs'
  ],
  questions_form: [
    'question_value',
    'other_questions'
  ]
}

// ----------------------------------------------------------------
// ------                   FOR MOBILES                        ----
// ----------------------------------------------------------------
export const globalColumnsMobiles = [ // columns, not categories
  'id', 'date', 'overall_result', 'error_codes', 'grade'
];

export const hardwareColumnsMobiles = [ // categories in allReportingColumns
  'hardware_general_mobiles', 'hardware_battery_mobiles'
];

export const testsColumnsMobiles = [ // ????
  'tests_mobiles'
];

// export const testsColumnsMobiles = [ // ????
//   'magnetometer', 'accelerometer', 'physical_Buttons', 'zoom_Gesture', 'touchscreen', 'touchAccuracy',
//   'swipe_Gesture', 'multi-Touch', 'dead_Pixels', 'microphones', 'microphone_1', 'microphone_2',
//   'earpiece', 'wiFi_Networks_Detection',  'cameras_Functionality', 'battery_Health'
// ];

export const locksColumnsMobiles = [ // columns, not categories
  'rooted_jailbroken', 'blacklisted', 'samsung_reactivation_lock', 'google_fpr_lock', 'find_my_iphone', 'sim_lock',
  'google_enterprise_configured', 'ios_mdm_configured', 'samsung_knox_configured',
  'xiaomi_account', 'google_account', 'huawei_account', 'device_genuine', 'battery_genuine', 'device_IMEI_needed', 'zero_touch_enrollment'
];

export const operationsColumnsMobiles = [
  'flash', 'wipe'
]

export const manualInputsColumnsMobiles = [      // ????
  'manual_inputs_mobiles'
]

// export const manualInputsColumnsMobiles = [      // ????
//   'welcome_screen', 'questions_form'
// ]



export const otherColumnsMobiles = [
  'carrier', 'carrier_bundle', 'esim_wipe', 'esim_active', 'esim_carrier', 'activate',
  'fed_check', 'warranty_end_date_activate', 'under_warranty', 'others_input_value'
  // + ????? 
]

//-----------------------------------------------

export const subHardwareColumnsMobiles = {
  hardware_general_mobiles: [
    'manufacturer', 'product', 'display_name', 'model_name', 'model_code', 'model_id', 'board', 'iemi', 'meid', 'iccid', 'serial_number',
    'region', 'region_code', 'region_info', 'capacity', 'front_color', 'back_color', 'sd_card_present', 'sim_card_present', 'dual_sim', 'port_number'
  ],

  hardware_battery_mobiles: [
    'max_capacity', 'design_capacity', 'cycle_count', 'soh', 'serial_number', 'manufacturing_date', 'grade'
  ]
}



// ----------------------------------------------------------------
// ------                   FOR DISKS                        ----
// ----------------------------------------------------------------

export const disksWipeColumns = [ // columns, not categories
  /*'id',*/ 'date', 'result', 'algorithm', 'eraser_rounds', 'time', 'manufacturer', 'model',
  'advertized_capacity', 'serial', 'health', 'uuid', 'ppid',
  'bps', 'customer_data', 'reallocated_sectors', 'power_on_hours', 'reported_uncorrectable_errors', 'command_timeout', 'current_pending_sector_count', 'offline_uncorrectable', 'disk_health_percentage', 'smart_attributes', 'rpm',
  "bus", "path", 'computed_health', 'computed_perf', 'order', 'lot'
];






  /*
  ... + 'memory', 'storage', 'mainboard', 'bios', 'video_adapter', 'network',
  'audio', 'screen', 'user Inputs', 'battery', 'other'

  */



  // deployment: [
  //   'date', 'serial', 'mac', 'version', 'initial_integration', 'final_integration',
  //   'local_wipe_report_generated', 'bench_report_generated', 'label_generated'
  // ],

  // deploymentForReport: [
  //   'serial', 'mac', 'version', 'start_date', 'end_date', 'is_active', 'is_failed'
  // ],


  // disk_smart_attribute: [
  //   'disk_id', 'attribute_name', 'attribute_value', 'attribute_worst', 'attribute_threshold'
  // ],

  // disk_tested: [
  //   'disk_id', 'test_id', 'disk_test', 'disk_test_result'
  // ],

  // disk_wiped: [
  //   'disk_id', 'algo', 'eraser_rounds', 'time', 'result'
  // ],

  // hardware: [
  //   'manufacturer', 'product', 'version', 'sku', 'serial', 'chassis_type', 'form_factor', 'cpu_slot_count',
  //   'motherboard', 'bios', 'total_ram_slots', 'total_ram', 'optic_drive', 'optic_type', 'hard_drive_count',
  //   'bluetooth', 'cardreader', 'biometrics', 'uuid', 'process_value'
  // ],

  // module: [
  //   'module_id', 'module_id_xtra', 'module_name', 'module_result', 'module_result_data',
  //   'module_parameter_1', 'module_parameter_2', 'start_date', 'end_date', 'closing_code', 'module_hwid'
  // ],

  // module_xtra: [
  //   'module_xtra_id', 'module_id', 'module_id_xtra', 'xtra_desc', 'xtra_value'
  // ],

  // test: [
  //   'test_id', 'test_result', 'start_date', 'end_date', 'skip_reason', 'driver'
  // ]

